import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from 'src/viewLayer/components/App/index.tsx';
import { UUID } from 'src/dataLayer/env';
import { getReturnToUrl } from 'src/dataLayer/localData/queryParams/returnToURLHelpers.ts';

const container = document.querySelector('[data-main]');
const root = createRoot(container);

/*
 * Redirects logged in users to the returnTo URL if a uuid is found, otherwise renders the app
 */

UUID
  ? window.location.replace(getReturnToUrl(window.location.search))
  : root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
